import { isReservedTenantLabel, isValidTenantSubdomainLabel } from "./getSubdomain";

/** Trim + lowercase for UI / API before checks or insert. */
export function normalizeStoreSubdomainInput(raw: string): string {
  return String(raw ?? "").trim().toLowerCase();
}

/** Whether the label is a valid, non-reserved DNS label for `stores.subdomain`. */
export function isAcceptableStoreSubdomainLabel(raw: string): boolean {
  const n = normalizeStoreSubdomainInput(raw);
  return n.length > 0 && isValidTenantSubdomainLabel(n) && !isReservedTenantLabel(n);
}
